import './App.css';
import { useState, useEffect, useContext } from 'react';
// import { DoubleCounter } from './components/Counter/DoubleCounter';
// import { HandleCounter } from './components/Counter/HandleCounter';
// <HandleCounter />            
// <DoubleCounter />
import { ContextProvider } from './context/MyContext';
import Routes from './Routes';
import React from 'react'
import { useLocation } from "react-router-dom";
import { initGA, logPageView } from "./services/analytics";
import { Funcoes } from './context/Funcoes';



function App() {  
  const [counter, setCounter] = useState(0);
  const [produtos, setProdutos] = useState([]);

  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    logPageView();
  }, [location]);

  return (    
      <ContextProvider value={{counter, setCounter, produtos, setProdutos}}>
        <Funcoes>
        <div className="App">                   
            <Routes />                        
        </div>
        </Funcoes>
      </ContextProvider>    
  );
}
export default App;
